export const shippingTranslate = {
  title: {
    en: "SHIPPING",
    cn: "運輸",
    jpn: "運送",
  },
  givenName: {
    en: "Given Name",
    cn: "名字",
    jpn: "名前",
  },
  surname: {
    en: "Surname",
    cn: "姓氏",
    jpn: "苗字",
  },
  email: {
    en: "Email Address",
    cn: "電郵地址",
    jpn: "電子メールアドレス",
  },
  addressLine1: {
    en: "Address Line 1",
    cn: "地址 (第一行)",
    jpn: "住所 (1行目)",
  },
  addressLine2: {
    en: "Address Line 2",
    cn: "地址 (第二行)",
    jpn: "住所 (2行目)",
  },
  country: {
    en: "Country or Region",
    cn: "國家或地區",
    jpn: "国または地域",
  },
  city: {
    en: "City",
    cn: "城市",
    jpn: "市",
  },
  contact: {
    en: "Contact Number",
    cn: "電話號碼",
    jpn: "電話番号",
  },
  spectrumId: {
    en: "Spectrum ID",
    cn: "频谱 ID",
    jpn: "スペクトル ID",
  },
  continue: {
    en: "Continue",
    cn: "繼續",
    jpn: "継続する",
  },
};
